import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Employment } from 'server/shared/models/employment';

@Component({
  selector: 'app-employment-date',
  templateUrl: './employment-date.component.html',
  styleUrls: ['./employment-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmploymentDateComponent implements OnInit {
  @Input() employment?: Employment;
  constructor() {}

  ngOnInit(): void {}
}
